import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import WalletModal from '../../components/Modals/WalletModal/WalletModal';
import { useAppSelector } from '../../store/reducers';
import { Routes } from '../../constants/routes';
import { useNavigate } from 'react-router-dom';
const ConnectWalletPage = () => {
    const navigate = useNavigate();
    const { isConnected } = useAppSelector((state) => state.wallet.activeWallet);
    const { loggedIn } = useAppSelector((state) => state.auth);
    useEffect(() => {
        isConnected && loggedIn && navigate(Routes.STABLES);
    }, [isConnected, navigate, loggedIn]);
    return _jsx(WalletModal, { isStatic: true, updateWalletsOnMount: false });
};
export default ConnectWalletPage;
